const Style = {
  mobileLinkStyle:
    "flex items-center gap-2 px-2 py-1 w-full rounded",
  desktopLinkStyle:
    "flex items-center gap-2 py-3 w-fit h-fit rounded-full hover:bg-[#CF2027] px-4 xl:px-6 transition-colors text-[9px] lg:text-[12px] xl:text-base",
};

export default Style;
